import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/brand";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    const r = await register(name, email, password);
    setLoading(false);
    if (r.ok) nav("/");
    else setErr(r.error || "Could not create account");
  };

  return (
    <div data-testid="register-page" className="min-h-[80vh] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <img src={LOGO_URL} alt="50 States Sober" className="w-16 h-16 rounded-full object-cover ring-1 ring-[var(--line)]" />
        </div>
        <h1 className="font-serif-display text-4xl text-center mb-2">Join the journey</h1>
        <p className="text-[var(--ink-soft)] text-center mb-10">Create an account to leave notes and message us.</p>

        <form onSubmit={submit} className="space-y-4">
          <input data-testid="register-name" required value={name} onChange={(e) => setName(e.target.value)}
            placeholder="Your name"
            className="w-full px-4 py-3 border border-[var(--line)] rounded-sm text-sm focus:outline-none focus:border-[var(--terracotta)] bg-[var(--bg)]" />
          <input data-testid="register-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="w-full px-4 py-3 border border-[var(--line)] rounded-sm text-sm focus:outline-none focus:border-[var(--terracotta)] bg-[var(--bg)]" />
          <input data-testid="register-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="Password (min 6 chars)"
            className="w-full px-4 py-3 border border-[var(--line)] rounded-sm text-sm focus:outline-none focus:border-[var(--terracotta)] bg-[var(--bg)]" />
          {err && <div data-testid="register-error" className="text-sm text-red-600">{err}</div>}
          <button data-testid="register-submit" disabled={loading}
            className="w-full bg-[var(--terracotta)] text-[var(--ink)] py-3 rounded-sm text-sm hover:bg-[var(--terracotta-dark)] disabled:opacity-50">
            {loading ? "Creating…" : "Create account"}
          </button>
        </form>

        <p className="text-sm text-center text-[var(--ink-soft)] mt-8">
          Already have an account? <Link to="/login" data-testid="register-to-login" className="text-[var(--forest)] underline">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
